<template>
  <div>
    <p><a href="https://zqlimy.com/">zqlimy</a></p>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="sass" scoped>
div
  position: absolute
  bottom: 0
  right: 0
  width: 100%
  margin: 0 auto
  p
    position: relative
    text-align: right
    margin: 0
    padding: 0 15px 10px 0
    a
      text-decoration: none
      color: gold
      &:hover
        color: pink
</style>
